import { render } from "./project_create_edit.vue?vue&type=template&id=4b88f27a&scoped=true"
import script from "./project_create_edit.vue?vue&type=script&lang=js"
export * from "./project_create_edit.vue?vue&type=script&lang=js"

import "./project_create_edit.vue?vue&type=style&index=0&id=4b88f27a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b88f27a"]])

export default __exports__